module.exports = __webpack_public_path__ + "static/TechBoot-a31ee6d4c9202e70fdabb671f3bfbc36.jpg";